import {
	ToothRestorationType,
	ToothSurface,
} from '../../../../graphql/graphql';
import { ALL_TOOTH_SURFACES } from '../../Helpers/surfaces/allToothSurfaces';

export const RESTORATION_ITEMS_SURFACES: Record<
	ToothRestorationType,
	ToothSurface[] | []
> = {
	[ToothRestorationType.Filling]: ALL_TOOTH_SURFACES,
	[ToothRestorationType.Veneer]: [
		ToothSurface.Buccal,
		ToothSurface.Lingual,
		ToothSurface.Palatal,
	],
	[ToothRestorationType.Crown]: [],
	[ToothRestorationType.Inlay]: [
		ToothSurface.Occlusal,
		ToothSurface.Mesial,
		ToothSurface.Distal,
	],
	[ToothRestorationType.Onlay]: [
		ToothSurface.Mesial,
		ToothSurface.Distal,
		ToothSurface.BuccalSurface,
		ToothSurface.PalatalSurface,
	],
	[ToothRestorationType.PartialCrown]: [
		ToothSurface.Mesial,
		ToothSurface.Occlusal,
		ToothSurface.Distal,
		ToothSurface.MesioBuccalCusp,
		ToothSurface.DistoBuccalCusp,
		ToothSurface.MesioPalatalCusp,
		ToothSurface.DistoPalatalCusp,
		ToothSurface.BuccalCusp,
		ToothSurface.PalatalCusp,
	],
};

export const PRESELECTED_RESTORATION_SURFACES: Record<
	ToothRestorationType,
	ToothSurface[]
> = {
	[ToothRestorationType.Filling]: [],
	[ToothRestorationType.Veneer]: [],
	[ToothRestorationType.Inlay]: [
		ToothSurface.Mesial,
		ToothSurface.Distal,
		ToothSurface.Occlusal,
	],
	[ToothRestorationType.Onlay]: [],
	[ToothRestorationType.PartialCrown]: [
		ToothSurface.Mesial,
		ToothSurface.Distal,
		ToothSurface.Occlusal,
	],
	[ToothRestorationType.Crown]: [],
};
